import ApiCore from '../api-core'
import { ACTIVE_BASE_REST } from '../constants'

export default class BillOfLading extends ApiCore {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/billOfLading'
    super(store, path)
  }

  list(filter, showProgress) {
    return this._request({
      action: 'list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  report(filter, showProgress) {
    return this._request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  process(model, showProgress) {
    return this._request({
      action: 'process',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  reset(id, showProgress) {
    return this._request({
      action: `${id}/reset`,
      method: 'PATCH',
      showProgress
    })
  }

  payableAmount(id, model, showProgress) {
    return this._request({
      action: `${id}/payableAmount`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  submitPaymentReceiver(id, model, showProgress) {
    return this._request({
      action: `${id}/submitPaymentReceiver`,
      method: 'POST',
      body: model,
      showProgress
    })
  }

  approvePaymentReceiver(id, showProgress) {
    return this._request({
      action: `${id}/approvePaymentReceiver`,
      method: 'PATCH',
      showProgress
    })
  }

  getById(id, showProgress) {
    return this._request({
      action: id,
      method: 'GET',
      showProgress
    })
  }

  achPaymentEnquiry(showProgress) {
    return this._request({
      action: 'achPaymentEnquiry',
      method: 'GET',
      showProgress
    })
  }
}
